module.exports = __webpack_public_path__ + "static/media/barcode.111a5967.png";